import React from 'react'

import { Suspense } from '~/components/elements/Suspense'

import { I18nextLoadedContent } from './components/I18nextLoadedContent'
import { useCurrentUserLanguage } from './hooks'

type I18nextProviderProps = {
  children: (args: { language: string }) => React.ReactNode
}
export const I18nextProvider = ({ children }: I18nextProviderProps) => {
  const { isLoading, language } = useCurrentUserLanguage()

  return (
    <Suspense loading={isLoading} loadingContainerSize="full">
      <I18nextLoadedContent language={language}>
        {children({ language })}
      </I18nextLoadedContent>
    </Suspense>
  )
}
